/**
 * Truncate a user's full name if it exceeds a given length.
 */
export function truncateName(name: string, maxLength: number = 22): string {
  if (!name) return "";

  const cleanName = name.trim();

  if (cleanName.length <= maxLength) return cleanName;

  return cleanName.slice(0, maxLength - 1).trimEnd() + "…";
}
